/**
 * custom-free-shipping.js
 *
 * Free-shipping bar rules for bikestore.dk:
 *   - If the cart contains a bike or a home trainer, the bar is HIDDEN. Their own
 *     freight is charged at checkout and everything else ships with them, so a
 *     "free shipping" message would be misleading.
 *   - Otherwise the bar works as the theme intends (cart total vs threshold).
 * The theme's own bar has no such rule, which is why a bike alone used to say
 * "Du har opnået GRATIS fragt!".
 *
 * A bike is a line whose product type is one of BIKE_TYPES (unless the title
 * says "frameset": framesets are not in the Cykler shipping profile, see
 * admin/shopify-descriptions/lib/shopify-cykler.js isFrameset), or a BCF
 * configured bike (line item property _MSRP). A home trainer is a line whose
 * title contains "hometrainer".
 *
 * IMPORTANT: the same rules exist in snippets/free-shipping-bar.liquid (first
 * render). If you change BIKE_TYPES or the rules, change both files.
 *
 * How it works: after every cart change (fetch wrapper, same pattern as
 * custom-cart-subtotal.js) and whenever the theme rewrites the bar (observer),
 * it reads /cart.js, hides or shows the bar, and rewrites the message and
 * progress bar the way the theme does.
 */
(function () {
  var BIKE_TYPES = [
    'børnecykel',
    'citybike',
    'elcykler',
    'gravel',
    'landevej',
    'landevejscykler',
    'mtb',
  ];

  function titleOf(item) {
    return String(item.product_title || item.title || '').toLowerCase();
  }

  function isBike(item) {
    if (item.properties && item.properties._MSRP != null) return true; // BCF configured bike
    var type = String(item.product_type || '').toLowerCase();
    return BIKE_TYPES.indexOf(type) !== -1 && titleOf(item).indexOf('frameset') === -1;
  }

  function isTrainer(item) {
    return titleOf(item).indexOf('hometrainer') !== -1;
  }

  function fmt(cents) {
    return (
      new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100) + ' DKK'
    );
  }

  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;
  var timer = null;
  var observer = new MutationObserver(function () {
    schedule(80);
  });

  function apply(node, cart) {
    var message = node.querySelector('.free-shipping-bar__message');
    var bar = node.querySelector('.free-shipping-bar__bar');
    if (!message || !bar) return;

    // A bike or a home trainer in the cart hides the bar completely.
    if (
      cart.items.some(function (item) {
        return isBike(item) || isTrainer(item);
      })
    ) {
      node.style.display = 'none';
      observer.takeRecords();
      return;
    }
    node.style.display = '';

    var rate =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
    var threshold = Math.round(parseInt(node.dataset.threshold, 10) * rate);
    if (!threshold) return;
    var thresholdCents = threshold * 100;
    var total = cart.total_price;

    if (total >= thresholdCents) {
      node.dataset.isOverThreshold = 'true';
      message.textContent = node.dataset.freeShippingSuccessMessage;
    } else {
      node.dataset.isOverThreshold = 'false';
      message.innerHTML = String(node.dataset.freeShippingPendingMessage).replace(
        '{{ remaining_amount }}',
        '<span class="fs-body-bold">' + fmt(thresholdCents - total) + '</span>'
      );
    }
    bar.style.setProperty(
      '--progress-width',
      (total < thresholdCents ? total / threshold : 100) + '%'
    );

    // Our own writes must not trigger the observer again.
    observer.takeRecords();
  }

  function attach(nodes) {
    nodes.forEach(function (node) {
      if (observed && observed.has(node)) return;
      if (observed) observed.add(node);
      observer.observe(node, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
      });
    });
  }

  function correct() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('[data-free-shipping-bar]')
    );
    if (!nodes.length) return;
    attach(nodes);
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        nodes.forEach(function (node) {
          apply(node, cart);
        });
      })
      .catch(function () {});
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(correct, ms);
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url =
      typeof arguments[0] === 'string'
        ? arguments[0]
        : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (res) {
        if (res.ok) schedule(200);
      });
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      schedule(0);
    });
  } else {
    schedule(0);
  }
})();
